import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b8d46c9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  type: "button",
  class: "btn mxa-header-icon mxa-header-button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#languageSelectModal",
  "data-test": "lang_icon"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<svg class=\"mxa-header-icon-svg\" viewBox=\"0 0 20 20\" width=\"50\" height=\"50\" data-v-b8d46c9c><path fill=\"none\" stroke=\"#fff\" d=\"M1,10.5 L19,10.5\" data-v-b8d46c9c></path><path fill=\"none\" stroke=\"#fff\" d=\"M2.35,15.5 L17.65,15.5\" data-v-b8d46c9c></path><path fill=\"none\" stroke=\"#fff\" d=\"M2.35,5.5 L17.523,5.5\" data-v-b8d46c9c></path><path fill=\"none\" stroke=\"#fff\" d=\"M10,19.46 L9.98,19.46 C7.31,17.33 5.61,14.141 5.61,10.58 C5.61,7.02 7.33,3.83 10,1.7 C10.01,1.7 9.99,1.7 10,1.7 L10,1.7 C12.67,3.83 14.4,7.02 14.4,10.58 C14.4,14.141 12.67,17.33 10,19.46 L10,19.46 L10,19.46 L10,19.46 Z\" data-v-b8d46c9c></path><circle fill=\"none\" stroke=\"#fff\" cx=\"10\" cy=\"10.5\" r=\"9\" data-v-b8d46c9c></circle></svg>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", _hoisted_1, _hoisted_3))
}